import { render, staticRenderFns } from "./propertyView.vue?vue&type=template&id=c6b3e49e&"
import script from "./propertyView.vue?vue&type=script&lang=js&"
export * from "./propertyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports